<template>
  <div class="rules-overview">
    <div class="rules-container">
      <!-- Columna para el contenido dentro de !collapsed -->
      <div v-if="!collapsed">
        <v-row class="text-n-values">
          <!-- Primera columna para los <p> -->
          <div class="rules-texts">
            <p v-bind:key="i" v-for="(ruleStatus, i) in progressRules" v-html="$t(`rules_RulesOverview.items.${ruleStatus.rule}`, {
              reference: Math.abs(ruleStatus.referenceValue),
            })
              ">
            </p>
          </div>

          <!-- Segunda columna para los elementos de progreso -->
          <div class="rules-values">
            <div class="progress-bar" v-bind:key="i" v-for="(ruleStatus, i) in progressRules">
              <v-icon v-if="isWarningRule(ruleStatus)" color="accent" class="mr-n4" small>fa-exclamation-circle</v-icon>
              <v-icon v-else-if="isCompletedRule(ruleStatus)" color="var(--v-mainGreen-base)" class="mr-n4"
                small>fa-check-circle</v-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-progress-linear v-bind="attrs" v-on="on" v-if="isProgressRule(ruleStatus.rule)" :height="12"
                    rounded :color="getProgressColor(ruleStatus)"
                    :background-color="!ruleStatus.rule.startsWith('MAX') ? '#C3FFE3' : 'var(--v-lightGray-base)'"
                    :value="getRulePerformancePercentage(ruleStatus)" />
                </template>
                <span>{{ getRulePerformanceText(ruleStatus) }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-row>
      </div>
    </div>
    <!-- Columna para el primer <p> -->
    <div class="rules-check-container">
      <!-- Columna para el primer <p> -->
      <div v-if="!collapsed">
        <v-row class="text-n-values">
          <!-- Primera columna para los <p> -->
          <div class="rules-texts">
            <p v-bind:key="i" v-for="(ruleStatus, i) in checkedRules" v-html="$t(`rules_RulesOverview.items.${ruleStatus.rule}`, {
              reference: Math.abs(ruleStatus.referenceValue),
            })">  
            </p>
          </div>

          <!-- Segunda columna para los elementos de progreso -->
          <div class="rules-values" v-bind:key="i" v-for="(ruleStatus, i) in checkedRules">
            <v-icon v-if="isWarningRule(ruleStatus)" small>fa-exclamation-circle</v-icon>
            <v-icon v-else-if="isCompletedRule(ruleStatus)" small>fa-check-circle</v-icon>
            <v-progress-linear v-if="isProgressRule(ruleStatus.rule)" :height="12" rounded
              :color="getProgressColor(ruleStatus)"
              :background-color="!ruleStatus.rule.startsWith('MAX') ? '#C3FFE3' : 'var(--v-lightGray-base)'"
              :value="getRulePerformancePercentage(ruleStatus)" />
            <p>
              {{ getRulePerformanceText(ruleStatus) }}
            </p>
          </div>
        </v-row>
      </div>
      <div v-else>
        <v-row class="text-n-values">
          <!-- Primera fila -->
          <div class="rules-texts">
            <p v-bind:key="i" v-for="(
ruleStatus, i
                  ) in $store.state.fundingTest.ruleStatuses">
              {{
                $t(`rules_RulesOverview.items.${ruleStatus.rule}`, {
                  reference: Math.abs(ruleStatus.referenceValue),
                })
              }}
            </p>
          </div>
          <div class="rules-values">
            <div class="d-flex align-center justify-start mb-1" v-bind:key="i" v-for="(
ruleStatus, i
                  ) in $store.state.fundingTest.ruleStatuses">
              <v-icon :color="wasBreakRule(ruleStatus.status) ? '#C42A14' : 'var(--v-mainGreen-base)'
                " small>{{
                  wasBreakRule(ruleStatus.status)
                    ? "fa-times-circle"
                    : "fa-check-circle"
                }}</v-icon>
            </div>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RulesOverview",
  computed: {
    progressRules() {
      let currentRules = this.$store.state.fundingTest.ruleStatuses;
      let progressRules = [];
      currentRules.forEach((rule) => {
        if (!this.isCompletedRule(rule) && !this.isWarningRule(rule)) {
          progressRules.push(rule);
        }
      });
      return progressRules;
    },
    checkedRules() {
      let currentRules = this.$store.state.fundingTest.ruleStatuses;
      let checkedRules = [];
      currentRules.forEach((rule) => {
        if (this.isCompletedRule(rule) || this.isWarningRule(rule)) {
          checkedRules.push(rule);
        }
      });
      return checkedRules;
    },
  },
  props: {
    collapsed: Boolean,
  },
  data() {
    return {};
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log("checked", this.checkedRules);
    // eslint-disable-next-line no-console
    console.log("progress", this.progressRules);
  },
  methods: {
    wasBreakRule(status) {
      return status === "VIOLATED" || status === "NOT_REACHED";
    },
    isProgressRule(rule) {
      let progressRules = [
        "MIN_TRADABLE_DAYS",
        "MAX_MAE",
        "MAX_DAILY_LOSS",
        "MAX_WEEKLY_LOSS",
        "MAX_DRAWDOWN",
        "MAX_TRADE_SIZE",
      ];
      return (
        progressRules.findIndex((progressRule) => progressRule === rule) !== -1
      );
    },
    getBackgroundColor(rule) {
      let progressRules = [
        "MIN_TRADABLE_DAYS",
        "MAX_MAE",
        "MAX_DAILY_LOSS",
        "MAX_WEEKLY_LOSS",
        "MAX_DRAWDOWN",
        "MAX_TRADE_SIZE",
      ];
      return (
        progressRules.findIndex((progressRule) => progressRule === rule) !== -1
      );
    },
    getRulePerformancePercentage(ruleStatus) {
      return (
        Math.abs(ruleStatus.currentValue * 100) /
        Math.abs(ruleStatus.referenceValue)
      );
    },
    isWarningRule(ruleStatus) {
      if (
        ruleStatus.rule === "CONSISTENCY" &&
        ruleStatus.status === "NOT_REACHED"
      )
        return true;

      let percentage = this.getRulePerformancePercentage(ruleStatus);
      if (String(ruleStatus.rule).startsWith("MAX"))
        return percentage > 90 && percentage < 100;

      return false;
    },
    isCompletedRule(ruleStatus) {
      return (
        ruleStatus.rule === "MAX_STOP_LOSS_PERCENTAGE" ||
        (!(String(ruleStatus.rule).startsWith("MAX") || String(ruleStatus.rule).startsWith("MIN")) &&
          (ruleStatus.status === "REACHED" ||
            ruleStatus.status === "NOT_VIOLATED"))
      );
    },
    getRulePerformanceText(ruleStatus) {
      let rule = ruleStatus.rule;
      if (this.isProgressRule(rule))
        return this.$t(`rules_RulesOverview.summary.${ruleStatus.rule}`, {
          reference: Math.abs(ruleStatus.referenceValue),
          value: Math.abs(ruleStatus.currentValue),
        });

      if (rule === "OVERNIGHT")
        return ruleStatus.status === "VIOLATED"
          ? this.$t("rules_RulesOverview.break")
          : this.$t("rules_RulesOverview.complying");
      else if (rule === "CONSISTENCY")
        return ruleStatus.status === "NOT_REACHED"
          ? this.$t("rules_RulesOverview.notComplying")
          : this.$t("rules_RulesOverview.complying");

      return ruleStatus.status === "VIOLATED"
        ? this.$t("rules_RulesOverview.break")
        : this.$t("rules_RulesOverview.complying");
    },
    getStatusIcons(ruleStatus) {
      switch (ruleStatus.status) {
        case "VIOLATED":
          return "fa-times-circle";
        case "NOT_VIOLATED":
          return "fa-check-circle";
        case "REACHED":
          return "fa-check-circle";
        case "NOT_REACHED":
          return "fa-minus-circle";
      }
    },
    getProgressColor(ruleStatus) {
      return String(ruleStatus.rule).startsWith("MAX") ? "#C42A14" : "var(--v-mainGreen-base)";
    },
    getStatusColor(ruleStatus) {
      return ruleStatus.status === "VIOLATED" ? "#FF6500" : "var(--v-mainGreen-base)";
      /*
      switch (ruleStatus.status) {
        case 'VIOLATED':
          return '#FF6500';
        case 'NOT_VIOLATED':
          return 'var(--v-mainGreen-base)';
        case 'REACHED':
          return 'var(--v-mainGreen-base)';
        case 'NOT_REACHED':
          return '#FFF75F';
      }*/
    },
    getParticipantStatusIcons(status) {
      switch (status) {
        case "ACTIVE":
          return "fa-check-circle";
        case "WINNER":
          return "fa-glass-cheers";
        case "PAUSED":
          return "fa-hourglass-half";
        case "DISQUALIFIED":
          return "fa-exclamation-circle";
      }
    },
    getParticipantStatusColor(status) {
      switch (status) {
        case "ACTIVE":
          return "var(--v-mainGreen-base)";
        case "WINNER":
          return "var(--v-mainGreen-base)";
        case "PAUSED":
          return "#FFF75F";
        case "DISQUALIFIED":
          return "#FF6500";
      }
    },
  },
};
</script>



<style lang="scss">
@import "src/global";

.rules-overview {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); // Adjust 200px as needed
  gap: 65px; // Adjust spacing between cards as needed

  @media (max-width: 1291px) {
    gap: 0px;
  }

  @media (max-width: 768px) {
    margin-top: 20px;
  }

  @media (max-width: 540px) {
    grid-template-columns: none;
  }

  .rules-container,
  .rules-check-container {
    .text-n-values {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      .rules-texts {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 50%;
        margin-right: 10px;

        p {
          @media (max-width: 768px) {
            font-size: 12px;
          }

          margin: 10px 0;
          line-height: 1;
          text-align: start;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          white-space: initial;
          -webkit-box-orient: vertical;
        }
      }

      .rules-values {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        @media (max-width: 768px) {
          justify-content: space-around;

          .v-icon {
            margin-bottom: 8px;
            margin-left: auto;
          }
        }

        .progress-bar {
          display: block;
        }

      }
    }
  }
}

.primary-color {
  color: $primary-color;
}

.white-content {
  color: $white-color;
}

.gray-content {
  color: #bdbdbd;
}

.custom-col {
  margin: 0;
}

@media (max-width: 800px) {
  .custom-col {
    width: 100%;
  }
}

.custom-col-checked {
  width: 400px;
}

.nowrap {
  white-space: nowrap;
}
</style>
